import { variables } from '@domain-group/fe-brary';
export var nameLineHeightOnMobile = '30px';
export var mobileAgencyNameFontSize = '20px';
export var buttonOutlineColorHover = variables.colour.secondaryDark;